import { DirectiveBinding, App } from "vue";
import { AppModule } from "@/core/store/modules/app-module";

function $can(action: string): boolean {
  if (!AppModule.config.auth?.grantedPolicies) return false;

  const grantedPolicies = AppModule.config.auth?.grantedPolicies as { [key: string]: boolean };
  return grantedPolicies[action];
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-unused-vars
function PermissionDirective(app: App, options?: any): void {
  app.config.globalProperties.$can = (action: string): boolean => {
    return $can(action);
  };
  app.directive("permission", {
    mounted: (el: HTMLElement, binding: DirectiveBinding) => {
      const key = binding.value;
      if (!$can(key)) {
        el.remove();
      }
    }
  });
}

function PermissionGuard(permission: string): boolean {
  return $can(permission);
}

export { PermissionDirective, PermissionGuard };
